import {Swiper, SwiperSlide} from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import './Carousel.css';
import tornadoImage from 'assets/images/tornado.png';
import leonhartImage from 'assets/images/leonhart.png';
import bonziniImage from 'assets/images/bonzini.png';

const Carousel = () => {
    return (
      <>
        <div className="container border-4 border-gray-800 rounded-lg py-12">
          <Swiper
            spaceBetween={50}
            autoplay={{ delay: 2300, disableOnInteraction: false }}
            speed={800}
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            slidesPerView={"auto"}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 2.5,
            }}
            modules={[Autoplay, EffectCoverflow]}
          >
            <SwiperSlide>
              <img
                loading="lazy"
                src={tornadoImage}
                alt="Tornado"
                className="relative"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                loading="lazy"
                src={leonhartImage}
                alt="Leonhart"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                loading="lazy"
                src={bonziniImage}
                alt="Bonzini"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                loading="lazy"
                src={tornadoImage}
                alt="Tornado"
                className="relative"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                loading="lazy"
                src={leonhartImage}
                alt="Leonhart"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                loading="lazy"
                src={bonziniImage}
                alt="Bonzini"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </>
    );
};

export default Carousel;